<template>
  <GeneralDialog class="tw-max-w-[450px]" @on-close="onCloseModal">
    <template #body>
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4"
      >
        <ContractSignYellowIcon />
        <Text variant="h4" textAlign="center" lineHeight="28px">
          {{ message }}
        </Text>
      </div>
    </template>
    <template #footer>
      <div class="tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3">
        <Button
          label="Confirm"
          :isActive="true"
          :disabled="isApiLoading"
          :loading="isApiLoading"
          @click="onConfirmModal"
        />
        <Button
          variant="secondary"
          label="Cancel"
          :disabled="isApiLoading"
          @click="onCloseModal"
        />
      </div>
    </template>
  </GeneralDialog>
</template>
<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ContractSignYellowIcon from "@/core/components/icons/ContractSignYellowIcon.vue";
const emits = defineEmits(["on-close", "on-confirm"]);
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
const store = useStore();
const isApiLoading = ref(false);

const holdEstimateAddTaskApi = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/getHoldEstimateAddTaskApi`]
);

const props = defineProps({
  message: {
    type: String,
    default: "Are you sure you would like to delete this Task?",
  },
  Loadingvalue: {
    type: Boolean,
    default: false,
  },
});
const onCloseModal = () => {
  if (!isApiLoading.value) {
    emits("on-close");
  }
};
const onConfirmModal = async () => {
  isApiLoading.value = true;
  await new Promise((resolve) => setTimeout(resolve, 3000));
  await emits("on-confirm");
  isApiLoading.value = false;
};
</script>
